// extracted by mini-css-extract-plugin
export var o_stories = "stories-module--o_stories--473fd";
export var o_stories__btn = "stories-module--o_stories__btn--57e45";
export var o_stories__card = "stories-module--o_stories__card--4514a";
export var o_stories__container = "stories-module--o_stories__container--4be5e";
export var o_stories__cta = "stories-module--o_stories__cta--23471";
export var o_stories__desc = "stories-module--o_stories__desc--3cfd9";
export var o_stories__h2 = "stories-module--o_stories__h2--e24b2";
export var o_stories__header = "stories-module--o_stories__header--e4386";
export var o_stories__main = "stories-module--o_stories__main--c01d7";